
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opportunities",
      function () {
        return require("private-next-pages/opportunities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opportunities"])
      });
    }
  